var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8001_9725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7536 2.3999C7.91924 2.3999 4.79999 5.51915 4.79999 9.35353C4.79999 14.1119 11.0227 21.0974 11.2875 21.3922C11.5365 21.6693 11.9707 21.6689 12.2194 21.3922C12.4841 21.097 18.7069 14.1115 18.7069 9.35353C18.7069 5.51953 15.5876 2.3999 11.7532 2.3999H11.7536ZM11.7536 12.8519C9.82461 12.8519 8.25524 11.2825 8.25524 9.35353C8.25524 7.42453 9.82461 5.85515 11.7536 5.85515C13.6826 5.85515 15.252 7.42453 15.252 9.35353C15.252 11.2825 13.6826 12.8519 11.7536 12.8519Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8001_9725"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.9069,
    height: 19.2,
    fill: "white",
    transform: "translate(4.79999 2.3999)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon-location.1c61d5b59d1cf55a73cfcb88a42a5148.svg";
export { ForwardRef as ReactComponent };